import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/Error';
import { useStyles } from './table';
import React from 'react';

export function ManageServerRow({ row, i, handleRconClick }) {

    const component = row.active ? <ActiveRow row={row} i={i} handleRconClick={handleRconClick} /> : <InactiveRow row={row} i={i} />

    return component
}

const InactiveRow = ({ row, i }) => {
    const classes = useStyles();

    return (
        <TableRow className={classes.inactive}>
            <TableCell></TableCell>
            <TableCell>{row.ip}</TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>Expired</TableCell>
        </TableRow>
    )
}

const ActiveRow = ({ row, i, handleRconClick }) => {
    const classes = useStyles();

    const handleRcon = () => {
        handleRconClick(row, i);
    };

    return (
        <TableRow className={row.isError ? classes.errorRow : row.selected ? classes.selectedRow : ''} key={row.name + i}>
            <TableCell>{row.name}</TableCell>
            <TableCell>{row.ip}</TableCell>
            <TableCell>{row.slots}</TableCell>
            <TableCell>{row.mapLabel}</TableCell>
            <TableCell>{row.gameMode}</TableCell>
            <TableCell align="center">{row.isLoading ?
                <CircularProgress></CircularProgress>
                : row.isError ?
                    <Box align="center"><ErrorIcon /></Box>
                    : row.selected ?
                        <Box align="center"><CheckCircleOutlineIcon /></Box>
                        : <Button onClick={handleRcon} variant="contained" color="secondary">RCON</Button>}
            </TableCell>
        </TableRow>)
}
